import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { ToastService } from '@teorema/patron';
import { Company, CustomerConsent, LgpdConsent } from 'src/app/models';
import { utils } from 'src/app/shared';
import { CustomerService, LgpdConsentService } from 'src/app/shared/services';

@Component({
  selector: 'app-lgpd-consent-request',
  templateUrl: './lgpd-consent-request.component.html',
  standalone: false,
})
export class LgpdConsentRequestComponent implements OnInit {
  message?: string;
  lgpdConsent = new LgpdConsent();
  company = new Company();
  companies?: Company[] = [];
  lgpdConsentsNotAccepted?: LgpdConsent[] = [];

  lgpdConsents: LgpdConsent[] = [];
  @Input() visible = false;
  send = false;
  customerConsents: CustomerConsent[] = [];

  constructor(
    private lgpdConsentService: LgpdConsentService,
    private customerService: CustomerService,
    private toastService: ToastService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe(async val => {
      if (val instanceof NavigationEnd) {
        const user = utils.getUser();

        if (user && this.authService.hasCustomerIdInCurrentCompanyGroup()) {
          const companyGroupId = utils.getCompanyGroup().id;
          await this.loadConsents(companyGroupId);
          await this.loadCustomerConsents();

          this.setLgpdConsentsNotAccepted();
          this.showMessages();
        }
      }
    });
  }

  async loadCustomerConsents() {
    let response = await this.customerService.findCustomerConsents().catch(() => {
      console.log('Não ha termos de consentimento cadastrados');
    });

    if (response) {
      if (typeof response === 'object')
        this.customerConsents = Object.values(response).filter(i => {
          return i?.id != null;
        });
      else this.customerConsents = response;
    }
  }

  async loadConsents(companyGroupId: string) {
    let response = await this.lgpdConsentService
      .findConsentsByCompanyGroup(companyGroupId)
      .catch(() => {
        console.log('Não ha termos de consentimento cadastrados');
      });

    if (response) {
      if (typeof response === 'object')
        this.lgpdConsents = Object.values(response).filter(i => {
          return i?.id != null;
        });
      else this.lgpdConsents = response;
    }
  }

  acceptTerms() {
    let hasError = false;
    this.lgpdConsentsNotAccepted?.forEach(lgpdConsent => {
      this.customerService.acceptTerms(lgpdConsent.id).catch(() => {
        this.toastService.show({
          color: 'error',
          message: 'Erro ao aceitar termos LGPD!',
        });

        hasError = true;
      });
    });

    if (!hasError) this.lgpdConsentsNotAccepted = [];

    this.visible = hasError;
  }

  showMessages() {
    if (this.lgpdConsentsNotAccepted?.length) {
      this.visible = true;
    }
  }

  setLgpdConsentsNotAccepted() {
    if (!this.lgpdConsents.length) return;
    this.lgpdConsents?.forEach(lgpdConsent => {
      let found = this.customerConsents.find(customerConsent => {
        return lgpdConsent.id == customerConsent.lgpd_consent_id;
      });

      if (
        !found ||
        (lgpdConsent.version &&
          found?.accepted_term_at &&
          new Date(found?.accepted_term_at) < new Date(lgpdConsent.version))
      )
        this.lgpdConsentsNotAccepted?.push(lgpdConsent);
    });
  }

  getMessage(company?: Company): LgpdConsent {
    let message: LgpdConsent = new LgpdConsent();

    this.lgpdConsents.forEach(lgpdConsent => {
      if (lgpdConsent.company_id == company?.person?.id) message = lgpdConsent;
    });

    return message;
  }
}
